/**
 * @generated SignedSource<<5431411d210656047bbb9580f772e324>>
 * @relayHash 9f52244a7f3eed3fe8da05ffdbbac625
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 654b56da81c86ed89056d06fa029adc14e7d2cacf7237c51370802723b666b10

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateEventWithSlugMutationInput = {
  attendeeLimit?: number | null | undefined;
  description?: string | null | undefined;
  endAt: string;
  name: string;
  ownerId: string;
  ownerType: string;
  startAt: string;
  timeZone: string;
};
export type EventNewContentCreateEventMutation$variables = {
  input: CreateEventWithSlugMutationInput;
};
export type EventNewContentCreateEventMutation$data = {
  readonly createEventWithSlug: {
    readonly event: {
      readonly owner: {
        readonly " $fragmentSpreads": FragmentRefs<"GuildEventsPastCard_guild" | "GuildEventsUpcomingCard_guild">;
      } | null | undefined;
      readonly prettyUrl: string;
    };
    readonly query: {
      readonly " $fragmentSpreads": FragmentRefs<"EventsScreenList_query">;
    };
  };
};
export type EventNewContentCreateEventMutation = {
  response: EventNewContentCreateEventMutation$data;
  variables: EventNewContentCreateEventMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prettyUrl",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v5 = [
  (v4/*: any*/),
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      "START_AT_DESC",
      "ID_ASC"
    ]
  },
  {
    "kind": "Literal",
    "name": "timeSelection",
    "value": "PAST"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startAt",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasExternalUrl",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasVenue",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "coverPhoto",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v6/*: any*/),
    {
      "alias": "mobileTransformUrl",
      "args": [
        {
          "kind": "Literal",
          "name": "transform",
          "value": {
            "dpr": 3,
            "w": 576
          }
        }
      ],
      "kind": "ScalarField",
      "name": "transformUrl",
      "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":576})"
    },
    {
      "alias": "desktopTransformUrl",
      "args": [
        {
          "kind": "Literal",
          "name": "transform",
          "value": {
            "dpr": 3,
            "w": 200
          }
        }
      ],
      "kind": "ScalarField",
      "name": "transformUrl",
      "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":200})"
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v15 = {
  "kind": "Literal",
  "name": "dpr",
  "value": 3
},
v16 = {
  "kind": "Literal",
  "name": "fit",
  "value": "cover"
},
v17 = {
  "kind": "Literal",
  "name": "h",
  "value": 100
},
v18 = {
  "kind": "Literal",
  "name": "w",
  "value": 100
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "membershipLevel",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailMd5",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryPhoto",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            (v15/*: any*/),
            (v16/*: any*/),
            {
              "kind": "Literal",
              "name": "fo",
              "value": "face"
            },
            (v17/*: any*/),
            (v18/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "transform"
        }
      ],
      "kind": "ScalarField",
      "name": "transformUrl",
      "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"fo\":\"face\",\"h\":100,\"w\":100})"
    },
    (v6/*: any*/)
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": [
    {
      "fields": [
        (v15/*: any*/),
        (v17/*: any*/),
        (v18/*: any*/)
      ],
      "kind": "ObjectValue",
      "name": "transform"
    }
  ],
  "kind": "ScalarField",
  "name": "defaultAvatarUrl",
  "storageKey": "defaultAvatarUrl(transform:{\"dpr\":3,\"h\":100,\"w\":100})"
},
v25 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v26 = {
  "alias": "eventOwner",
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v7/*: any*/),
        (v14/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "primaryPhoto",
          "plural": false,
          "selections": [
            (v12/*: any*/),
            (v6/*: any*/),
            {
              "alias": null,
              "args": [
                {
                  "fields": [
                    (v15/*: any*/),
                    (v16/*: any*/),
                    (v17/*: any*/),
                    (v18/*: any*/)
                  ],
                  "kind": "ObjectValue",
                  "name": "transform"
                }
              ],
              "kind": "ScalarField",
              "name": "transformUrl",
              "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":100,\"w\":100})"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "colorPalette",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GuildMembership",
          "kind": "LinkedField",
          "name": "myMembership",
          "plural": false,
          "selections": [
            (v19/*: any*/),
            (v6/*: any*/)
          ],
          "storageKey": null
        },
        (v12/*: any*/)
      ],
      "type": "Guild",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v20/*: any*/),
        (v21/*: any*/),
        (v14/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isMe",
          "storageKey": null
        },
        (v12/*: any*/),
        (v22/*: any*/),
        (v23/*: any*/),
        (v24/*: any*/)
      ],
      "type": "User",
      "abstractKey": null
    },
    (v25/*: any*/)
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v28 = [
  (v20/*: any*/),
  (v21/*: any*/),
  (v12/*: any*/),
  (v22/*: any*/),
  (v23/*: any*/),
  (v24/*: any*/),
  (v6/*: any*/)
],
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v30 = {
  "alias": "attendeesByRelevance",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "status": {
          "in": [
            "ATTENDING_IN_PERSON",
            "ATTENDING_VIRTUAL",
            "WAITING_IN_PERSON",
            "WAITING_VIRTUAL"
          ]
        }
      }
    },
    {
      "kind": "Literal",
      "name": "first",
      "value": 8
    }
  ],
  "concreteType": "EventAttendeesConnection",
  "kind": "LinkedField",
  "name": "eventAttendeesByRelevance",
  "plural": false,
  "selections": [
    (v27/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "EventAttendeesEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventAttendee",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": (v28/*: any*/),
              "storageKey": null
            },
            (v6/*: any*/)
          ],
          "storageKey": null
        },
        (v29/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "eventAttendeesByRelevance(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\",\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}},first:8)"
},
v31 = [
  (v27/*: any*/)
],
v32 = {
  "alias": "attendingCount",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "status": {
          "in": [
            "ATTENDING_IN_PERSON",
            "ATTENDING_VIRTUAL"
          ]
        }
      }
    }
  ],
  "concreteType": "EventAttendeesConnection",
  "kind": "LinkedField",
  "name": "eventAttendees",
  "plural": false,
  "selections": (v31/*: any*/),
  "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\"]}})"
},
v33 = {
  "alias": "waitingCount",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "status": {
          "in": [
            "WAITING_IN_PERSON",
            "WAITING_VIRTUAL"
          ]
        }
      }
    }
  ],
  "concreteType": "EventAttendeesConnection",
  "kind": "LinkedField",
  "name": "eventAttendees",
  "plural": false,
  "selections": (v31/*: any*/),
  "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}})"
},
v34 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "orderBy",
      "value": [
        "SORT_ORDER_ASC",
        "CREATED_AT_ASC"
      ]
    }
  ],
  "concreteType": "EventTicketingTiersConnection",
  "kind": "LinkedField",
  "name": "eventTicketingTiers",
  "plural": false,
  "selections": (v31/*: any*/),
  "storageKey": "eventTicketingTiers(orderBy:[\"SORT_ORDER_ASC\",\"CREATED_AT_ASC\"])"
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endAt",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "EventAttendee",
  "kind": "LinkedField",
  "name": "myAttendance",
  "plural": false,
  "selections": [
    (v36/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentStatus",
      "storageKey": null
    },
    (v6/*: any*/)
  ],
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v14/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "GuildMembership",
          "kind": "LinkedField",
          "name": "myMembership",
          "plural": false,
          "selections": [
            (v19/*: any*/),
            (v36/*: any*/),
            (v6/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "Guild",
      "abstractKey": null
    },
    (v25/*: any*/)
  ],
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "Form",
  "kind": "LinkedField",
  "name": "attendeeForm",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v41 = {
  "alias": "eventItemPresentations",
  "args": [
    {
      "kind": "Literal",
      "name": "orderBy",
      "value": [
        "CREATED_AT_ASC",
        "ID_ASC"
      ]
    }
  ],
  "concreteType": "PresentationsConnection",
  "kind": "LinkedField",
  "name": "presentations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PresentationsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Presentation",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            (v12/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "presenterFirstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "presenterLastName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "presenter",
              "plural": false,
              "selections": (v28/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "transform",
                  "value": {
                    "dpr": 3,
                    "h": 24,
                    "w": 24
                  }
                }
              ],
              "kind": "ScalarField",
              "name": "guestPresenterAvatarUrl",
              "storageKey": "guestPresenterAvatarUrl(transform:{\"dpr\":3,\"h\":24,\"w\":24})"
            },
            (v6/*: any*/)
          ],
          "storageKey": null
        },
        (v29/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "presentations(orderBy:[\"CREATED_AT_ASC\",\"ID_ASC\"])"
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v43 = [
  "timeSelection",
  "orderBy"
],
v44 = {
  "kind": "Literal",
  "name": "timeSelection",
  "value": "UPCOMING"
},
v45 = [
  (v4/*: any*/),
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      "START_AT_ASC",
      "ID_ASC"
    ]
  },
  (v44/*: any*/)
],
v46 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "EventsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      (v29/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v6/*: any*/),
          (v8/*: any*/),
          (v7/*: any*/),
          (v2/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v13/*: any*/),
          (v26/*: any*/),
          (v30/*: any*/),
          (v32/*: any*/),
          (v33/*: any*/),
          (v34/*: any*/),
          (v12/*: any*/),
          (v35/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/),
          (v39/*: any*/),
          (v40/*: any*/),
          (v41/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v42/*: any*/)
],
v47 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "and": [
        {
          "not": {
            "metadata": {
              "containsKey": "meetupEventID"
            }
          }
        },
        {
          "allowGlobalListing": {
            "equalTo": true
          }
        }
      ]
    }
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  (v44/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventNewContentCreateEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateEventWithSlugMutationPayload",
        "kind": "LinkedField",
        "name": "createEventWithSlug",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "GuildEventsPastCard_guild"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "GuildEventsUpcomingCard_guild"
                      }
                    ],
                    "type": "Guild",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventsScreenList_query"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventNewContentCreateEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateEventWithSlugMutationPayload",
        "kind": "LinkedField",
        "name": "createEventWithSlug",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": "pastEvents",
                        "args": (v5/*: any*/),
                        "concreteType": "EventsConnection",
                        "kind": "LinkedField",
                        "name": "eventsByTimeSelection",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Event",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  (v2/*: any*/),
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v13/*: any*/),
                                  (v26/*: any*/),
                                  (v30/*: any*/),
                                  (v32/*: any*/),
                                  (v33/*: any*/),
                                  (v34/*: any*/),
                                  (v12/*: any*/),
                                  (v35/*: any*/),
                                  (v37/*: any*/),
                                  (v38/*: any*/),
                                  (v39/*: any*/),
                                  (v40/*: any*/),
                                  (v41/*: any*/),
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v29/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v42/*: any*/)
                        ],
                        "storageKey": "eventsByTimeSelection(first:3,orderBy:[\"START_AT_DESC\",\"ID_ASC\"],timeSelection:\"PAST\")"
                      },
                      {
                        "alias": "pastEvents",
                        "args": (v5/*: any*/),
                        "filters": (v43/*: any*/),
                        "handle": "connection",
                        "key": "GuildEventsPastCard_guild_pastEvents",
                        "kind": "LinkedHandle",
                        "name": "eventsByTimeSelection"
                      },
                      (v6/*: any*/),
                      {
                        "alias": "upcomingEvents",
                        "args": (v45/*: any*/),
                        "concreteType": "EventsConnection",
                        "kind": "LinkedField",
                        "name": "eventsByTimeSelection",
                        "plural": false,
                        "selections": (v46/*: any*/),
                        "storageKey": "eventsByTimeSelection(first:3,orderBy:[\"START_AT_ASC\",\"ID_ASC\"],timeSelection:\"UPCOMING\")"
                      },
                      {
                        "alias": "upcomingEvents",
                        "args": (v45/*: any*/),
                        "filters": (v43/*: any*/),
                        "handle": "connection",
                        "key": "GuildEventsUpcomingCard_guild_upcomingEvents",
                        "kind": "LinkedHandle",
                        "name": "eventsByTimeSelection"
                      }
                    ],
                    "type": "Guild",
                    "abstractKey": null
                  },
                  (v25/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "alias": "upcomingEvents",
                "args": (v47/*: any*/),
                "concreteType": "EventsConnection",
                "kind": "LinkedField",
                "name": "eventsByTimeSelection",
                "plural": false,
                "selections": (v46/*: any*/),
                "storageKey": "eventsByTimeSelection(filter:{\"and\":[{\"not\":{\"metadata\":{\"containsKey\":\"meetupEventID\"}}},{\"allowGlobalListing\":{\"equalTo\":true}}]},first:10,timeSelection:\"UPCOMING\")"
              },
              {
                "alias": "upcomingEvents",
                "args": (v47/*: any*/),
                "filters": [
                  "timeSelection",
                  "filter"
                ],
                "handle": "connection",
                "key": "EventsScreenList_query_upcomingEvents",
                "kind": "LinkedHandle",
                "name": "eventsByTimeSelection"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "viewer",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "authorizationLevel",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "654b56da81c86ed89056d06fa029adc14e7d2cacf7237c51370802723b666b10",
    "metadata": {},
    "name": "EventNewContentCreateEventMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "26832350f1534b2f7d983615e7588326";

export default node;
